export const BACKGROUND_GREY = 'grey';
export const BACKGROUND_WHITE = 'white';
export const BACKGROUND_TRANSPARENT = 'transparent';
export const BACKGROUND_BLUE = 'blue';
